import { toast } from 'react-toastify';

// error message templates
const ERROR_TEMPLATES = {
  AFFILIATE_MISMATCH: {
    CLIENT_USER: (action) => `The affiliate of the user you have selected for this client is different from the affiliate of the client you are ${action}. You (or your related admin) first need to adjust the affiliates related to the client.`,
    USER_CLIENT: (action) => `The affiliates of the client you have selected for this user is different from the affiliate of the user you are ${action}. You (or your related admin) first need to adjust the affiliates related to the client.`,
    PLAYLIST: () => `The affiliates of the playlist does not exactly match the affiliates assigned to your profile. Please contact your manager to change the affiliates assigned to you or to the playlist.`,
    COLLECTION: () => `The affiliates of the collection does not exactly match the affiliates assigned to your profile. Please contact your manager to change the affiliates assigned to you or to the collection.`,
    CAMPAIGN_PLAYLIST: (action) => `The affiliate of the client is different from the playlist you are selecting. You cannot ${action} it. You (or your related admin) first need to change the affiliate of the client or the affiliate of the playlist.`,
    SCHEDULE_PLAYLIST: (action) => `The affiliate of the client is different from the playlist you are selecting. You cannot ${action} it. You (or your related admin) first need to change the affiliate of the client or the affiliate of the playlist.`,
    SCHEDULE_COLLECTION: (action) => `The affiliate of the client is different from the collection you are selecting. You cannot ${action} it. You (or your related admin) first need to change the affiliate of the client or the affiliate of the collection.`,
  },
  CLIENT_LINKED_ENTITIES: () => `The client you are trying to delete still have campaigns and devices assigned to it. Please reassign or delete those subelements before making the modifications.`,
};

const ACTION_MAP = {
  POST: 'creating',
  PUT: 'editing', 
  DELETE: 'deleting'
};

const generateErrorCode = (method, entity, type = 'AFFILIATE_MISMATCH') => {
  return `${method}_${entity}_${type}`;
};

const buildErrorCodes = () => {
  const codes = {};
  
  ['POST', 'PUT', 'DELETE'].forEach(method => {
    const action = ACTION_MAP[method];
    
    // CLIENT_USER_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'CLIENTS_USER')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.CLIENT_USER(action);
    
    // CLIENT_AFFILIATE_MISMATCH  
    codes[generateErrorCode(method, 'CLIENTS')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.CLIENT_USER(action);
    
    // USER_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'USERS')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.USER_CLIENT(action);
    
    // USER_NOT_LINKED_TO_CLIENT
    codes[generateErrorCode(method, 'USERS', 'NOT_LINKED_TO_CLIENT')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.USER_CLIENT(action);
    
    // PLAYLIST_AFFILIATE_MISMATCH (只有PUT和DELETE)
    if (method !== 'POST') {
      codes[generateErrorCode(method, 'PLAYLISTS')] = 
        ERROR_TEMPLATES.AFFILIATE_MISMATCH.PLAYLIST();
    }
    
    // COLLECTION_AFFILIATE_MISMATCH (只有PUT和DELETE)
    if (method !== 'POST') {
      codes[generateErrorCode(method, 'COLLECTIONS')] = 
        ERROR_TEMPLATES.AFFILIATE_MISMATCH.COLLECTION();
    }
    
    // CAMPAIGN_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'CAMPAIGNS')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.CAMPAIGN_PLAYLIST(action);
    
    // CAMPAIGN_PLAYLIST_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'CAMPAIGNS_PLAYLIST')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.CAMPAIGN_PLAYLIST(action);
    
    // SCHEDULE_PLAYLIST_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'SCHEDULES_PLAYLIST')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.SCHEDULE_PLAYLIST(action);
    
    // SCHEDULE_PLAYLIST_COLLECTION_AFFILIATE_MISMATCH
    codes[generateErrorCode(method, 'SCHEDULES_PLAYLIST_COLLECTION')] = 
      ERROR_TEMPLATES.AFFILIATE_MISMATCH.SCHEDULE_COLLECTION(action);
  });
  
  // 特殊错误代码
  codes.DELETE_CAMPAIGNS_UNKNOWN_CLIENT = ERROR_TEMPLATES.CLIENT_LINKED_ENTITIES();
  codes.CLIENT_HAS_LINKED_ENTITIES = ERROR_TEMPLATES.CLIENT_LINKED_ENTITIES();
  
  return codes;
};

const ERROR_CODES = buildErrorCodes();

const DEFAULT_ERROR_MESSAGE = 'An unexpected error has occurred, please try again';


class ErrorHandler {
  constructor() {
    this.errorCodes = ERROR_CODES;
  }

  // Handle API errors
  handleApiError(error) {
    const { data } = error.response;
    
    // Handle 403 errors with specific error messages
    if ((data.code === 403 || data.code === 400) && data?.message) {
      this.showError(data.message);
      return;
    }

    // Default error
    this.showError(DEFAULT_ERROR_MESSAGE);
  }

  showError(code, customMessage) {
    const message = customMessage || this.errorCodes[code] || DEFAULT_ERROR_MESSAGE;
    toast.error(message);
  }
}

export const errorHandler = new ErrorHandler(); 
export { ERROR_CODES }; 